import { useContext, useState } from 'react'
import { People } from '@mui/icons-material'
import ListUsers from './ListUsers'
import { useNavigate,useSearchParams } from 'react-router-dom'
import { useIsMounted } from '../utils/ReactUtils.js'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { Button, Paper } from '@mui/material'
import { Stack } from '@mui/system'

import UserRolesSelection from './UserRolesSelection.js'
import RoleContext from '../auth/RoleContext.js'
import { Link } from 'react-router-dom'

export default function ListUsersPage (props = {}) {
  const roleDetails = useContext(RoleContext)
  const [searchParams, setSearchParams] = useSearchParams()
  const [listRoleId, setListRoleId] = useState(parseInt(searchParams.get('r') ?? '0'))
  const navigate = useNavigate()
  const isMounted = useIsMounted()

  const breadcrumb = <span><People/> User Management</span>

  const [showFilters, setShowFilters] = useState(true)
  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  const [showAddRecord, setShowAddRecord] = useState(false)
  const addRecord = () => {
    navigate('/users/edit/new')
  }
  const hideAddRecord = () => {
    setShowAddRecord(false)
  }

  const handleViewSelectChange = async (event) => {
      const roleId = event.target.value
      if (roleId > 0) {
        setSearchParams((s) => {
          s.set('r', `${roleId}`)
          return s
        })
      }
      setListRoleId(roleId)
      // await getUserList(roleId)
  }


  return (
    <Page { ...props} breadcrumb={breadcrumb} commandBar={<ListViewCommandBar actionButtons={<Button variant='outlined' onClick={() => navigate('/users/report')}>User Report</Button>} toggleFilters={toggleFilters} addRecord={addRecord} showCancel={false}  /> }>
      <Paper sx={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: '10px 1px'}}>
          <Stack rowGap={.5} >
            <Stack direction='row' columnGap={1}>
              <UserRolesSelection noSelectionLabel='Select a Role' onSelect={handleViewSelectChange} value={listRoleId}/>
            </Stack>
            <ListUsers searchFilter={{ roleId: listRoleId }} showFilters={showFilters} showAddRecord={showAddRecord} hideAddRecord={hideAddRecord} />
          </Stack>
      </Paper>
    </Page>
  )
}